<template>
    <div class="col-xl-9 col-md-12 box-col-70">
        <div class="file-content">
            <div class="card">
                <div class="card-header">
                    <div class="d-md-flex d-sm-block">
                        <form class="form-inline" action="#" method="get">
                            <div class="form-group d-flex mb-0"> <i class="fa fa-search"></i>
                                <input class="form-control-plaintext" type="text" placeholder="Search...">
                            </div>
                        </form>
                        <div class="flex-grow-1 text-end">
                            <form class="d-inline-flex" action="#" method="POST" enctype="multipart/form-data"
                                name="myForm">
                                <div class="btn btn-primary" onclick="getFile()"> <vue-feather
                                        type="plus-square"></vue-feather> Add
                                    New</div>
                                <div style="height: 0px;width: 0px; overflow:hidden;">
                                    <input id="upfile" type="file" onchange="sub(this)">
                                </div>
                            </form>
                            <div class="btn btn-outline-primary ms-3"><vue-feather type="upload"></vue-feather> Upload
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body file-manager">
                    <h5>Quick Access </h5>
                    <ul class="quick-file d-flex flex-row">
                        <li>
                            <div class="quick-box"><i class="fa fa-youtube-play font-danger"></i></div>
                            <h6>Videos</h6>
                        </li>
                        <li>
                            <div class="quick-box"><i class="fa fa-th font-info"></i></div>
                            <h6>Apps</h6>
                        </li>
                        <li>
                            <div class="quick-box"><i class="fa fa-file-text-o font-secondary"></i></div>
                            <h6>Document</h6>
                        </li>
                        <li>
                            <div class="quick-box"><i class="fa fa-music font-warning"></i></div>
                            <h6>Music</h6>
                        </li>
                        <li>
                            <div class="quick-box"><i class="fa fa-download font-primary"></i></div>
                            <h6>Download</h6>
                        </li>
                        <li>
                            <div class="quick-box"><i class="fa fa-folder font-info"></i></div>
                            <h6>Folder</h6>
                        </li>
                        <li>
                            <div class="quick-box"><i class="fa fa-file-archive-o font-secondary"></i></div>
                            <h6>Zip File</h6>
                        </li>
                        <li>
                            <div class="quick-box"><i class="fa fa-trash font-danger"></i></div>
                            <h6>Trash</h6>
                        </li>
                    </ul>
                    <folderConent />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import folderConent from "./folderConent.vue"
export default {
    components: {
        folderConent
    }
}
</script>